import React, { useEffect, useState } from 'react';
import CardBlog from '../../components/CardBlog/CardBlog';
import ContactCard from '../../components/Contact/ContactCard';

function Blog(){
    const [ post, setPost ] = useState([]);

    const consultarApi = async () => {
        const url = "https://jacxdev-backend.herokuapp.com/posts"
        const resp = await fetch(url);
        const data = await resp.json();

        const posts = data.map((post) => {
            return {
                id: post.id,
                content: post.content,
                image: post.image.url
            }
        })

        setPost(posts)
    }

    useEffect( () => {
        consultarApi()
    }, []);

    return(
        <div className="container">
            <div className="row">
                {
                   post.map((infopost) => {
                       return(
                        <CardBlog
                            key={ infopost.id }
                            extract={ infopost.content }
                            background={ infopost.image }
                        />
                       )
                   })
                }
                <ContactCard />
            </div>
        </div>
    )
}

export default Blog;